import { observable, action, runInAction, toJS } from "mobx";
import {
  customersData,
  foodData,
  commentsData,
  platformData,
  submarketData,
} from "./data";
import moment from "moment";
import { message } from "antd";
import _ from "lodash";
import request from "@/method/axios";

class store {
  @observable date = moment().format("YYYY-W");
  @observable loading = false;
  @observable saving = false;
  @observable room = 0;
  @observable customers = [];
  @observable food = [];
  @observable comments = [];
  @observable platform = [];
  @observable submarket = [];
  @action
  getData = async (date) => {
    runInAction(() => {
      this.loading = true;
      this.customers = [];
      this.food = [];
      this.comments = [];
      this.platform = [];
      this.submarket = [];
      this.date = date;
    });
    try {
      const year = moment(date, "YYYY-W").format("YYYY");
      const week = moment(date, "YYYY-W").format("W");
      const res = await request.post("/api/data", {
        list: [
          {
            name: "comments",
            key: "kpi_comments",
            year,
            week,
          },
          {
            name: "customer",
            key: "kpi_customer",
            year,
            week,
          },
          {
            name: "food",
            key: "kpi_food",
            year,
            week,
          },
          {
            name: "platform",
            key: "kpi_platform",
            year,
            week,
          },
          {
            name: "submarket",
            key: "kpi_submarket",
            year,
            week,
          },
        ],
      });
      console.log(res);

      runInAction(() => {
        this.loading = false;
        this.customers = res.data.customer.length
          ? res.data.customer
          : JSON.parse(JSON.stringify(customersData));
        this.food = res.data.food.length
          ? res.data.food
          : JSON.parse(JSON.stringify(foodData));
        this.comments = res.data.comments.length
          ? res.data.comments
          : JSON.parse(JSON.stringify(commentsData));
        this.platform = res.data.platform.length
          ? res.data.platform
          : JSON.parse(JSON.stringify(platformData));
        this.submarket = res.data.submarket.length
          ? res.data.submarket
          : JSON.parse(JSON.stringify(submarketData));
        this.room = _.get(res, "data.customer.[0].room", 0);
      });
    } catch (error) {
      console.error(error);
      message.error("数据处理失败！");
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  @action
  onSave = async () => {
    let date = this.date;
    const year = moment(date, "YYYY-W").format("YYYY");
    const week = moment(date, "YYYY-W").format("W");
    let customers = toJS(this.customers).map((x) => ({
      ...x,
      room: this.room,
      year,
      week,
    }));
    let food = toJS(this.food).map((x) => ({ ...x, year, week }));
    let comments = toJS(this.comments).map((x) => ({ ...x, year, week }));
    let platform = toJS(this.platform).map((x) => ({ ...x, year, week }));
    let submarket = toJS(this.submarket).map((x) => ({ ...x, year, week }));

    runInAction(() => {
      this.saving = true;
    });
    try {
      const res = await request.post("/es/kpifollow", {
        customers,
        food,
        comments,
        platform,
        submarket,
        year,
        week,
      });

      if (res.code == 200) {
        message.success("保存成功！");
        if (!customers[0].id) {
          this.getData(this.date);
        }
      } else {
        message.error(res.msg);
      }
      runInAction(() => {
        this.saving = false;
      });
    } catch (error) {
      message.error("保存失败！");
      console.error(error);
      runInAction(() => {
        this.saving = false;
      });
    }
  };
}

const Month = new store();

export default Month;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/store.js